<!-- <app-nav-bar></app-nav-bar>
<main class="container-fluid pb-3 flex-grow-1 d-flex flex-column flex-sm-row overflow-auto">
  <div class="row flex-grow-sm-1 flex-grow-0">
    <app-side-bar></app-side-bar>
    <div class="col overflow-auto h-100">
      <div class="bg-light border rounded-3 p-3">
        <router-outlet></router-outlet>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</main> -->
<!-- https://dev.to/codeply/bootstrap-5-sidebar-examples-38pb -->

<router-outlet></router-outlet>